import { inject, computed, unref } from 'vue';
function useProfile() {
  const profile = inject('profile');
  return computed(() => unref(profile));
}
export { useProfile };